export const AnswerStatuses = {
  ACCEPTED: 'ACCEPTED',
  CANCELED: 'CANCELED',
  COUNTER_OFFER: 'COUNTER_OFFER',
  NO_RESPONSE: 'NO_RESPONSE',
  COUNTER_OFFER_REJECTED: 'COUNTER_OFFER_REJECTED',
  COUNTER_OFFER_ACCEPTED: 'COUNTER_OFFER_ACCEPTED',
};

export type TAnswerStatuses = typeof AnswerStatuses[keyof typeof AnswerStatuses];

export interface IMeetingConfirmation {
  userId: number;
  meetingConfirmationId: number;
  answerStatus: TAnswerStatuses;
  offeredTime?: string;
}

export interface IOuterMemberConfirmation {
  meetingConfirmationId: number;
  memberId: number;
  answerStatus: TAnswerStatuses;
}

export const getDateFromOfferedType = (offeredTime: string) => {
  if(offeredTime) {
    return new Date(offeredTime);
  }
  return null;
}
